import { redirect } from 'react-router-dom'

import { SavingsCustomerStatus } from '@cash-web/protos/squareup/cash/piggybank/api/v2/models.pb'
import { FlowType } from '@cash-web/protos/squareup/cash/plasma/flows/FlowProto.pb'
import { Country } from '@cash-web/protos/squareup/common/countries.pb'
import { ensureQueryData } from '@cash-web/shared-data-access-api/ensureQueryData'
// eslint-disable-next-line @nx/workspace/no-new-franklin-get-profile -- pre-existing usage; migrate per #cash-profile-migration
import { useQueryGetProfile, useQueryGetSavingsOverview } from '@cash-web/shared-data-access-api/react-query'
import { JourneyLoaderFunction } from '@cash-web/shared-journey-util-main'

export const savingsNuxOrHomeLoader: JourneyLoaderFunction = async ({ context }) => {
  if (!context?.queryClient) return null
  const [profileResponse, savingsResponse] = await Promise.all([
    ensureQueryData(context.queryClient, useQueryGetProfile.asQueryConfig({})),
    ensureQueryData(context.queryClient, useQueryGetSavingsOverview.asQueryConfig({})),
  ])

  const country = profileResponse?.profile?.country_code
  const status = savingsResponse?.customer?.customer_status
  if (country === Country.US) {
    if (status === SavingsCustomerStatus.SAVINGS_CUSTOMER_STATUS_ELIGIBLE) {
      throw redirect(`/dl/flow/${FlowType.SAVINGS_NUX}`)
    }
    if (status === SavingsCustomerStatus.SAVINGS_CUSTOMER_STATUS_ADOPTED) {
      return context.browserNavigate('/account/savings')
    }
  }

  return context.browserNavigate('/account/activity')
}
